import React from 'react'
import {withStyles} from 'external/material'
import MuiButton from '@mui/material/Button'

export const BlueButton = withStyles(theme => ({
  root: {
    color: '#fff',
    boxShadow: 'none',
    backgroundColor: '#2ca5ec',
    border: 'solid 1px #2ca5ec'
  }
}))(props => (<MuiButton {...{...props, variant: "contained"}}>{props.children}</MuiButton>))

export const WhiteButton = withStyles(theme => ({
  root: {
    color: '#4f576e',
    boxShadow: 'none',
    backgroundColor: '#fff',
    border: 'solid 1px #4f576e'
  }
}))(props => (<MuiButton {...{...props, variant: "contained"}}>{props.children}</MuiButton>))
